import {baseMethods} from './baseMethod';
import {BooleanResult, ResultType, ResultTypesEnum} from './internal';

export const booleanType: ResultType = {
  name: ResultTypesEnum.BOOLEAN,
  properties: {
    is_false: BooleanResult,
  },
  methods: {
    ...baseMethods,
  },
};
